import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'out-home-cta',
  imports: [CommonModule, RouterLink],
  templateUrl: './home-cta.component.html',
  styleUrl: './home-cta.component.scss',
})
export class HomeCtaComponent {
  constructor(public auth: AuthService) {}

  login() {
    this.auth.loginWithRedirect();
  }
}
